import { create } from 'zustand'
import { BonusesSlice, createBonusesSlice } from './slices/bonusesSlice'

export interface CountdownFSBonusStoreState extends BonusesSlice {
    hasActiveBonusesLeft: boolean
    setHasActiveBonusesLeft: (hasMore: boolean) => void
    showRemainingSpinsBanner: boolean
    setShowRemainingSpinsBanner: (shouldShow: boolean) => void
    isModalOpened: boolean
    setIsModalOpened: (isModalOpened: boolean) => void
    isThereClaimingError: boolean
    setIsThereClaimingError: (isThereClaimingError: boolean) => void
    isBonusAlreadyClaimed: boolean
    setIsBonusAlreadyClaimed: (isBonusAlreadyClaimed: boolean) => void
    hasActiveBonusExpired: () => boolean
    isRecovery: boolean
    setIsRecovery: (isRecovery: boolean) => void
}

export const useCountdownFSBonusStore = create<CountdownFSBonusStoreState>((set, get) => ({
    ...createBonusesSlice(set),
    hasActiveBonusesLeft: false,
    setHasActiveBonusesLeft: (hasActiveBonusesLeft: boolean) => {
        set({ hasActiveBonusesLeft })
    },
    showRemainingSpinsBanner: false,
    setShowRemainingSpinsBanner: (shouldShow: boolean) => {
        set({ showRemainingSpinsBanner: shouldShow })
    },
    isModalOpened: false,
    setIsModalOpened: (isModalOpened: boolean) => set({ isModalOpened }),
    isBonusAlreadyClaimed: false,
    setIsBonusAlreadyClaimed: (isBonusAlreadyClaimed: boolean) => {
        set({ isBonusAlreadyClaimed })
    },
    isThereClaimingError: false,
    setIsThereClaimingError: (isThereClaimingError: boolean) => {
        set({ isThereClaimingError })
    },
    hasActiveBonusExpired: () => {
        return +(get().activeBonus?.expirationTime ?? 0) - Date.now() <= 999 // Ignore any milliseconds left as long as no whole seconds left
    },
    isRecovery: false,
    setIsRecovery: (isRecovery: boolean) => {
        set({ isRecovery })
    },
}))
